<template>
    <div>
        <!-- Modal -->
        <div id="templateRenameModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Rename Content
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="templateForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <div class="form-group">
                                    <input v-model="templateRename" class="form-control"
                                           type="text"
                                           id="template_rename">
                                    <input type="hidden">

                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="rename-template-save" name="save-as-template"
                                @click.prevent="renameTemplate"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="">

            <div class="">
                <!-- Modal -->
                <div id="templateNameModal" class="modal fade" role="dialog">
                    <div class="modal-dialog modal-md">
                        <!-- Modal content-->
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title text-lg">
                                    Template Name
                                </h4>
                                <button type="button" dusk="modal-close-button"
                                        class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                        data-dismiss="modal">close
                                </button>
                            </div>
                            <div class="modal-body">
                                <form @keydown="templateForm.errors.clear($event.target.name)">
                                    <div class="mb-2">
                                        <div class="form-group">
                                            <input v-model="templateForm.template_name" class="form-control"
                                                   :class="{'border-red': templateForm.errors.has('template_name')}"
                                                   type="text"
                                                   id="template_name">

                                        </div>
                                        <div class="text-red text-xs" v-if="templateForm.errors.has('template_name')">
                                            {{ templateForm.errors.get('template_name') }}
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button id="save-as-template" name="save-as-template"
                                        @click.prevent="saveAsTemplate"
                                        class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">
                    <div class="col-md-3 inline-block float-left section-title">
                        Introduction
                    </div>
                    <div class="col-md-7 inline-block float-left templateDiv">
                        <b-dropdown toggle-class="templateDropDown" id="dropdown-1" :text="templateSelector" class="">
                            <span v-if="section.all_templates.length > 0">
                                <b-dropdown-item class="dropdownCustomItem" @click="deselectedTemplateDropdown()"><span class="templateName deselectTemplate">Deselect Template</span></b-dropdown-item>
                                <span v-for="templateItem in section.all_templates">
                                    <b-dropdown-item class="dropdownCustomItem" @click="selectedTemplateDropdown(templateItem.id)"><span class="templateName">{{templateItem.template_name}}</span><i v-if="role" class="fa fa-trash templateDelete" @click="removeTemplate(templateItem.id)" aria-hidden="true"></i><i v-if="role" class="fa fa-pencil templateDelete templateRename" @click="renameTemplateModal(templateItem)" aria-hidden="true"></i></b-dropdown-item>
                                </span>
                            </span>
                            <span v-else>
                                <b-dropdown-item class="dropdownCustomItem"><span class="templateName">No template has been created yet.</span></b-dropdown-item>
                            </span>
                        </b-dropdown>
                        <button @click="updateTemplate" v-if="showUpdateTemplateButton && role" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn">
                            Update Template
                        </button>
                        <button v-if="role" @click="openSaveAsTemplateModal" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn">
                            Save New Template
                        </button>
                    </div>
                    <div class="col-md-2 inline-block text-right pr-0">
                        <button @click="saveIntroduction" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn" id="saveSectionButton">
                            {{saveButtonText}}
                        </button>
                    </div>
                </div>
                <div class="card bg-white shadow w-100">
                    <div class="">
                        <div class="">
                            <ckeditor-proposal v-model="tempSection.text" :proposal="proposal" @changesOccur="changesOccur"></ckeditor-proposal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import axios from "axios";

let token = document.head.querySelector('meta[name="csrf-token"]');
export default {
    props: ['section', 'proposal', 'team', 'role','selectedTemplateObject','tempProposal'],
    components: {Multiselect},
    data() {
        return {
            resourceFiles: this.proposal.resource_files,
            revertedResources: [],
            data_loading: false,
            hasOneFile: false,
            signatureButton: false,
            tempSection: {
                id: this.section.id,
                proposal_id: this.section.proposal_id,
                name: this.section.name,
                include_in_report: this.section.include_in_report,
                order: this.section.order,
                tag: this.section.tag,
                deleteable: this.section.deleteable,
                text: this.section.text,
                signature_section: this.section.signature_section,
                proposal_template_id: this.section.proposal_template_id,
                all_templates: this.section.all_templates
            },
            editName: false,
            templateForm: new Form({
                template_name: this.section.template_name,
                template_text: this.section.text,
                template_type: 'introduction',
                section_id: this.section.id,
            }),
            selectedTemplate: null,
            allTemplates: this.section.all_templates,
            signature: this.section.signature_section,
            resourceServer: {
                revert: (uniqueFileId, load, error) => {
                    let file = JSON.parse(uniqueFileId).resource;
                    this.revertedResources.push(file.token);
                    axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                    if (2) formData.append('directory_id', 2);
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/proposal-resource-files');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };

                    request.send(formData);
                    setTimeout(function(){
                        $("#openResourceImageAddModal").modal("hide");
                    }, 3000);
                }
            },
            showUpdateTemplateButton:false,
            templateSelector:'Pick a template',
            showSaveTemplateButton:false,
            sectionSaved:true,
            saveButtonText:'Save',
            templateIsSelected:false,
            appliedTemplateCounter:1,
            templateRename:'',
            templateRenameId:'',
        }
    },
    mounted() {
        Bus.$on('signature', data => {
            this.signatureFooter(data);
        });

        Bus.$emit('signature', this.section.signature_section);

        Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: null});

        this.selectAppliedTemplate();
        Bus.$on('newEditorData', data => {
            this.tempSection.text = data;
        });

        if(this.selectedTemplateObject.length > 0){
            this.selectedTemplateObject.forEach(item => {
                if(item.type == 'introduction' && item.section_id == this.section.id){
                    this.sectionSaved = false;
                    this.saveButtonText = 'Click To Save';
                    this.saveButtonBlink();
                    this.selectedTemplateDropdown(item.template_id);
                }
            });
        }

        Bus.$on('fetchLatestResourceFile', data => {
            this.fireSuccessToast('Resource file deleted.');
            this.fetchData();
        });

        if(this.section.all_templates.length > 0){
            this.section.all_templates.forEach(item => {
                if(item.id == this.section.proposal_template_id){
                    this.templateSelector = item.template_name;
                    this.selectedTemplateByMethod(item.id);
                }
            });
        }

    },
    created() {
        this.fetchData();
    },
    methods: {
        toolButton(button, text){
            var data = [];
            data['button'] = button;
            data['text'] = text;
            Bus.$emit('toolButton', data);
        },
        handleOnProcessFile(error, resourceFile) {
            this.tempSection = JSON.parse(resourceFile.serverId).section;
            this.saveTitle();
        },
        handleOnProcessResourceFile(error, resourceFile) {
            setTimeout(() => {
                this.$refs.pondResourceImage.removeFile(resourceFile.id);
                if (!resourceFile.serverId) return;
                let file = JSON.parse(resourceFile.serverId).resource;
                if (this.revertedResources.includes(file.token)) return;
                file.thumb_url = route('resource-files.show-thumb', {resourceFile: file.token});
                file.id_key = file.id;
                this.resourceFiles.unshift(file);
                this.hasOneFile = this.resourceFiles.length > 0;
            }, 2000);
        },
        handleOnAddFileStart() {
            this.hasOneFile = true;

        },
        async uploadFile() {
            let files = this.$refs.responsiveFileInput.files;
            if (files) {
                let i = 0;
                for (i; i < files.length; i++) {
                    const formData = new FormData();

                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                    if (2)  formData.append('directory_id', 2)
                    formData.append('test', files[i]);
                    await axios.post('/api/resource-files', formData).catch(err => {
                        window.Swal.fire({
                            title: "An error occurred!",
                            text: "The file could not be uploaded!",
                            buttons: true,
                        });
                    });
                }
                window.location.reload();
            }
        },
        openResourceImageAddModal() {
            $("#openResourceImageAddModal").modal("show");
        },
        fetchData() {
            let params = {
                // company_id: this.section.company.id,
                project_id: this.proposal.project_id,
                folder_id: 2,
            };

            this.data_loading = true;
            axios.get(route('api.proposal-resource-files.index'), {params}).then(({data}) => {
                this.resourceFiles = data.data.map(resourceFile => {
                    resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                    resourceFile.is_thumb_loaded = false;
                    resourceFile.id_key = resourceFile.id;
                    return resourceFile;
                });
                this.hasOneFile = this.resourceFiles.length > 0;
                this.pagination = data;
                this.data_loading = false;
            });
        },
        selectAppliedTemplate(){
            if (this.allTemplates && this.tempSection.proposal_template_id != null) {
                this.selectedTemplate = this.allTemplates.find(template => template.id == this.tempSection.proposal_template_id)
            }
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'error',
                title: message,
            });
        },
        saveIntroduction() {
            for (var i in CKEDITOR.instances) {
                this.tempSection.text = CKEDITOR.instances[i].getData();
            }
            this.editName = false;
            if(this.selectedTemplate) {
                this.tempSection.proposal_template_id = this.selectedTemplate.id;
            }else{
                this.tempSection.proposal_template_id = null;
            }
            if(this.tempProposal.locked == 1){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            this.$emit('introductionChanged', this.tempSection);
        },
        openSaveAsTemplateModal() {
            this.templateForm.errors.clear();
            this.templateForm.template_name = null;
            $("#templateNameModal").modal("show");
        },
        saveAsTemplate() {
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            if (this.tempSection.text.length == 0) {
                this.fireErrorToast('Introduction text section is required to save as template.');
            } else {
                this.templateForm.template_text = this.tempSection.text;
                this.templateForm.post('/proposal-template/save')
                    .then((data) => {

                        if (data.status === 'success') {
                            this.fireSuccessToast(data.message);
                            $("#templateNameModal").modal("hide");
                            this.allTemplates = data.templates;
                            this.tempSection.all_templates = data.templates;
                            this.selectedTemplateDropdown(data.created_template.id);
                            Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: null});
                            this.$emit('introductionChanged', this.tempSection, false);
                        } else {
                            this.fireErrorToast(data.message);
                        }
                    });
            }
        },
        updateTemplate() {
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            if (this.tempSection.text.length == 0) {
                this.fireErrorToast('Introduction text section is required to update current template.');
            } else {
                this.templateForm.template_text = this.tempSection.text;
                this.templateForm.put('/proposal-template/' + this.selectedTemplate.id + '/update')
                    .then((data) => {

                        if (data.status === 'success') {
                            this.fireSuccessToast(data.message);
                            this.allTemplates = data.templates;
                            Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: null});
                            // this.$emit('introductionChanged', this.tempSection, false);
                            for (var i in CKEDITOR.instances) {
                                Bus.$emit('updatedSectionTemplate', CKEDITOR.instances[i].getData())
                            }
                            this.showUpdateTemplateButton = false;
                        } else {
                            this.fireErrorToast(data.message);
                        }
                    });
            }
        },
        removeTemplate(id) {
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            this.section.all_templates.forEach(item => {
                if(item.id == id){
                    this.selectedTemplate = item;
                }
            });
            if(!this.selectedTemplate) {
                this.fireErrorToast('Please select a template to delete.');
            }else{

                Swal.fire({
                    title             : "Are you sure?",
                    text              : "Once deleted, you will not be able to recover this content!",
                    icon              : "warning",
                    buttons           : true,
                    showCancelButton  : true,
                    confirmButtonColor: 'red',
                    confirmButtonText : 'I\'m sure!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true,
                }).then(result => {
                    if (result.value) {

                        this.templateForm.post('/proposal/' + this.tempSection.proposal_id + '/proposal-template/' + this.selectedTemplate.id + '/delete')
                            .then((data) => {
                                if (data.status === 'success') {
                                    this.fireSuccessToast(data.message);
                                    this.tempSection.proposal_template_id = null;
                                    this.selectedTemplate = null;
                                    this.allTemplates = data.templates;
                                    Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: data.proposal});
                                    Bus.$emit('showButton', {
                                        button: 'template',
                                        proposal_template_id: this.tempSection.proposal_template_id
                                    });
                                    this.getStandardCustomSectionTemplate();
                                    this.templateSelector='Pick a template';
                                    this.deselectedTemplateDropdown();
                                }else{
                                    this.fireErrorToast(data.message);
                                }
                            });
                    }
                });

            }
        },
        applyTemplate() {
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            if (this.selectedTemplate) {
                this.tempSection.proposal_template_id = this.selectedTemplate.id;
                this.tempSection.text = this.selectedTemplate.text.trim();
                Bus.$emit('showButton', {
                    button: 'template',
                    proposal_template_id: this.selectedTemplate.id
                });
            }
        },
        signatureFooter(data) {
            this.tempSection.signature_section = data;
            this.signature = this.tempSection.signature_section;
        },
        signatureFooterBtn() {
            Bus.$emit('signature', !this.signatureButton);
        },
        deleteProposal() {
            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('proposal.destroy', self.proposal.id))
                        .then((response) => {
                            if (response.data.status === 'success') {
                                window.location = '/project/' + response.data.project_id + '/edit';
                            } else {
                                self.initTempProposal(response.data.proposal);
                                self.fireErrorToast(response.data.message);
                            }
                        });
                }
            });
        },
        unlock() {
            let self = this;
            axios.put('/proposal/' + self.proposal.id + '/unlock')
                .then((response) => {
                    if (response.data.status === 'success') {
                        self.fireSuccessToast(response.data.message);
                        window.location.reload();
                    } else {
                        self.fireErrorToast(response.data.message);
                        self.initTempProposal(response.data.proposal);
                    }
                });
        },
        lock() {
            let self = this;
            axios.put('/proposal/' + self.proposal.id + '/lock')
                .then((response) => {
                    if (response.data.status === 'success') {
                        self.fireSuccessToast(response.data.message);
                        window.location.reload();
                    } else {
                        self.fireErrorToast(response.data.message);
                        self.initTempProposal(response.data.proposal);
                    }
                });
        },
        addImageToCKeditor(thumbnail, id){
            for (var i in CKEDITOR.instances) {
                var img = new Image();
                img.src = thumbnail;
                img.onload = function() {
                    if(this.width > 500 && this.height < 1100){
                        var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="500" height="auto" style="max-width:100%" src="' + thumbnail + '" /></span>';
                        CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
                    }else if(this.height > 1100){
                        var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="auto" height="770" style="max-width:100%" src="' + thumbnail + '" /></span>';
                        CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
                    }else{
                        var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="500" height="auto" style="max-width:100%" src="' + thumbnail + '" /></span>';
                        CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
                    }
                }
            }
        },
        selectedTemplateDropdown(selectedValue){
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            this.tempSection.all_templates.forEach(item => {
                if(item.id == selectedValue){
                    this.selectedTemplate = item;
                    this.tempSection.proposal_template_id = item.id;
                    this.tempSection.text = item.text;
                    this.templateSelector=item.template_name;
                    this.showSaveTemplateButton = false;
                    this.templateIsSelected = true;
                    Bus.$emit('templateIsSelected', item.text);
                    Bus.$emit('selectedTemplateObjectEmit', {'template_id':item.id, 'section_id':this.section.id, 'type':item.type});
                }
            });
        },
        saveButtonBlink(){
            for (var i in CKEDITOR.instances) {
                var currentData = CKEDITOR.instances[i].getData();
            }
            if(!this.sectionSaved){
                if(!this.templateIsSelected){
                    this.showSaveTemplateButton = true;
                }else if(this.selectedTemplate && this.templateIsSelected && (this.tempSection.text !== currentData.trim())){
                    this.showUpdateTemplateButton = true;
                }
                const elm= $('#saveSectionButton');
                elm.addClass('bgglow');
            }
        },
        deselectedTemplateDropdown(){
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            this.tempSection.text = '';
            this.templateSelector='Pick a template';
            this.showSaveTemplateButton = true;
            this.templateIsSelected = false;
            this.tempSection.proposal_template_id = null;
            this.selectedTemplate = null;
            Bus.$emit('templateIsSelected', '')
            Bus.$emit('deselectedTemplateObjectEmit', {'section_id':this.section.id});
            this.tempSection.proposal_template_id = null;
            this.selectedTemplate = null;
        },
        showResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','block', 'important');
        },
        hideResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','none', 'important');
        },
        deleteResourceFile(resourceFile){
            Bus.$emit('delResourceFile', resourceFile);
        },
        renameTemplateModal(template){
            $('#templateRenameModal').modal("show");
            this.templateRename = template.template_name;
            this.templateRenameId = template.id;
        },
        renameTemplate() {
            if(this.tempProposal.locked){
                this.fireErrorToast('Proposal is locked.');
                return false;
            }
            var templateData = {
                'name':this.templateRename,
                'id':this.templateRenameId
            };
            axios.post('/proposal-template/rename', templateData)
                .then((data) => {
                    if (data.data.status == 'success') {
                        this.fireSuccessToast(data.data.message);
                        $("#templateRenameModal").modal("hide");
                        this.allTemplates = data.data.templates;
                        Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: null});
                        this.$emit('introductionChanged', this.tempSection, false);
                        this.templateRename = '';
                        this.templateRenameId = '';
                        this.templateSelector = data.data.selectedTemplate.template_name;
                    } else {
                        this.fireErrorToast(data.data.message);
                    }
                });
        },
        selectedTemplateByMethod(selectedValue){
            this.section.all_templates.forEach(item => {
                if(item.id == selectedValue){
                    this.selectedTemplate = item;
                    this.tempSection.proposal_template_id = item.id;
                    this.templateSelector=item.template_name;
                    this.showSaveTemplateButton = false;
                    this.templateIsSelected = true;
                    Bus.$emit('selectedTemplateObjectEmit', {'template_id':item.id, 'section_id':this.section.id, 'type':item.type});
                }
            });
        },
        getStandardCustomSectionTemplate(){
            axios.get('/proposal/all-standard-section-templates/' + this.section.id)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.tempSection.all_templates = response.data.data;
                        if(response.data.data.length > 0){
                            response.data.data.forEach(item => {
                                if(item.id == this.section.proposal_template_id){
                                    this.templateSelector = item.template_name;
                                    this.selectedTemplateByMethod(item.id);
                                }
                            });
                        }
                    } else {
                        this.tempSection.all_templates = [];
                    }
                });
        },
        changesOccur(){
            this.sectionSaved = false;
            this.saveButtonText = 'Click To Save';
            this.saveButtonBlink();
        }
    },
    beforeDestroy () {
        Bus.$off('updateTemplate');
        Bus.$off('removeTemplate');
    }
}
</script>

<style scoped>
.reports-frame-style {
    height: 75vh;
    width: 100%;
    border: 1px solid grey;
    border-radius: 7px;
}
.resource-images-div {
    float: left;
    padding: 0 5px;
    margin-bottom: 10px;
    height: 100px;
    overflow:hidden;
}
.resource-images-div img{
    height:60px;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}
span.resource-images-name {
    font-size: 10px;
    word-break: break-word;
}
.resource-images {
    height: 55px;
}
.tool-buttons {
    border: 1px solid #01b1af;
    margin: 0 5px;
    font-size: 12px;
    padding: 10px 0;
    color: #01b1af;
    text-align: center;
    margin-bottom: 9px;
    max-width: 93% !important;
    margin-right: 5px;
    margin-left: 7px;
}
.tool-buttons:hover {
    background-color: #01b1af1c;
    cursor: pointer;
}
.deleteBtn {
    color: #dc3545 !important;
    border-color: #dc3545 !important;
    max-width: 95% !important;
}
.deleteBtn:hover{
    background-color: #dc35451c !important;
}
.resource-images:hover {
    cursor: pointer;
}
.upload-icon-proposal {
    font-size: 18px;
    margin-left: 6px;
}
.upload-btn-proposal:hover{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #fff;
    color: #01b1af !important;
}
.upload-btn-proposal{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #01b1af;
    color: #fff !important;
    cursor: pointer;
}
.cke_editable p{
    margin:0 !important;
}
.proposal-editor-save-btn {
    background: #fff;
    border: 1px solid #01b1af;
    /*box-shadow: unset !important;*/
    color: #01b1af;
    font-size: 12px;
}
.proposal-editor-save-btn:hover {
    background: #01b1af;
    border: 1px solid #fff;
    box-shadow: unset !important;
    color: #fff;
}
.templateDelete {
    float: right;
    padding: 2px 9px;
    border-radius: 3px;
}
.templateDelete:hover {
    background: red;
    color: #fff;
}
.templateName {
    width: 75% !important;
    overflow: hidden;
    float: left;
    word-break: break-word;
    font-size: 13px;
}

.bgglow {
    -webkit-animation: bgglow 1500ms infinite;
    -moz-animation: bgglow 1500ms infinite;
    -o-animation: bgglow 1500ms infinite;
    animation: bgglow 1500ms infinite;
}
@-webkit-keyframes bgglow {
    0% { -webkit-box-shadow: 0 0 3px #00FF01; }
    50% { -webkit-box-shadow: 0 0 40px #00FF01; }
    100% { -webkit-box-shadow: 0 0 3px #00FF01; }
}

@-moz-keyframes bgglow {
    0% { -moz-box-shadow: 0 0 3px #00FF01; }
    50% { -moz-box-shadow: 0 0 40px #00FF01; }
    100% { -moz-box-shadow: 0 0 3px #00FF01; }
}

@-o-keyframes bgglow {
    0% { box-shadow: 0 0 3px #00FF01; }
    50% { box-shadow: 0 0 40px #00FF01; }
    100% { box-shadow: 0 0 3px #00FF01; }
}

@keyframes bgglow {
    0% { box-shadow: 0 0 3px #00FF01; }
    50% { box-shadow: 0 0 40px #00FF01; }
    100% { box-shadow: 0 0 3px #00FF01; }
}
</style>
<style>
.templateDropDown,
.templateDropDown:hover,
.templateDropDown:active,
.templateDropDown:focus,
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle{
    background: #fff;
    color: #333;
    border:0;
    box-shadow: unset !important;
    font-size:13px;
}
.dropdownCustomItem .dropdown-item:hover,
.dropdownCustomItem .dropdown-item:focus,
.dropdownCustomItem .dropdown-item:target,
.dropdownCustomItem .dropdown-item:active{
    text-decoration: none;
    background-color: transparent !important;
}
.dropdownCustomItem .dropdown-item, .dropdownCustomItem .dropdown-item {
    text-decoration: none;
    background-color: transparent !important;
}
ul.dropdown-menu.show {
    width: 300%;
}
.section-title{
    width: 100%;
    height: 35px;
    overflow: hidden;
    font-size: 18px !important;
    padding: 7px 0;
}

button#dropdown-1__BV_toggle_ {
    max-width: 140px;
    overflow: hidden;
}
.deselectTemplate{
    color: red !important;
}
.delete-resource-file-button {
    width: 20px;
    height: 20px;
    font-size: 12px;
    background: red;
    text-align: center;
    color: white;
    position: absolute;
    top: 0px;
    z-index: 999;
    display: none;
    cursor: pointer;
}
.templateRename:hover{
    background: #01b1af !important;
    color: #fff;
}
.templateDiv ul{
    min-width: 350px !important;
}
</style>
